import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useContext, useEffect, useState} from "react";
import {setAppGuidCookie} from "../common/appCookie";
import {Grid} from "@mui/material";
import MDBox from "../../components/MDBox";
import CustomerHeader from "../common/CustomerHeader";
import Footer from "../Footer";
import CustomerPageLayout from "../Layout/CustomerPageLayout";
import CustomerCalendarPane from "./pane/CustomerCalendarPane";
import {CompanyContext} from "../../lib/CompanyProvider";
import {UserContext} from "../../lib/UserProvider";
import Meta from "../common/Meta";

export default function CustomerDashboard(props) {
  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const [userContext, setUserContext] = useContext(UserContext);
  const [company, setCompany] = useState(companyContext?.company);

  const showLogin = props?.showLogin;

  const [searchParams, setSearchParams] = useSearchParams();
  const [companyGuid, setCompanyGuid] = useState(searchParams.get('psb_co_id') || null);

  const navigate = useNavigate();
  let {guid} = useParams();

  useEffect(() => {
    setCompanyGuid(companyContext?.company?.guid);
  }, [companyContext?.company?.guid]);

  useEffect(() => {
    if (guid) {
      setAppGuidCookie(guid);
    }
  }, [guid]);

  useEffect(() => {
    if (companyGuid) {
      setAppGuidCookie(companyGuid);
    }
  }, [companyGuid]);

  useEffect(() => {
    if (showLogin) {
      setUserContext({...userContext, showLogin: true});
    }
  }, [])

  useEffect(() => {
    if (companyContext?.company?.guid) {
      setPageReady(true);
      setCompany(companyContext?.company);
    }
  }, [companyContext?.company]);

  const [pageReady, setPageReady] = useState(false);


  return (
    <>
      <Meta pageTitle={'Calendar'}/>
      <CustomerPageLayout>
        <CustomerHeader props={props}/>

        {pageReady && <MDBox p={2} style={{
          clear:'both',
          display:'block',
          width:'100%',
        }}>
          <CustomerCalendarPane/>
        </MDBox>
        }
        <Footer/>
      </CustomerPageLayout>
    </>
  )
}